import { PlaidConnectionWithAccounts } from "@common/types/plaidConnection";
import { FinancialAccount } from "@common/types/financialAccount";
import { IntegrationAccount } from "@common/types/integrationAccount";

function isValidAccountType(account: FinancialAccount) {
    return account.isBusiness !== null;
}

function isValidAccountEntity(account: FinancialAccount) {
    return !!account.entityId;
}
export function isValidAccount(account: IntegrationAccount) {
    return (
        account.financialAccount &&
        isValidAccountType(account.financialAccount) &&
        isValidAccountEntity(account.financialAccount)
    );
}

export function isValidConnection(connection: PlaidConnectionWithAccounts) {
    return connection.accounts.every(isValidAccount);
}
